import React, { Component, Fragment } from 'react';
import {
    Container,
    Row, Col, Input, Label, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';
import PermissionWrapper from '../../auth/PermissionWrapper';

class Teams extends Component {

    constructor(props) {
        super(props);

        this.blankTeam = {
            teamName: '',
            teamOrder: 0,
            active: true
        }

        this.state = {
            newTeam: { ...this.blankTeam },
            editTeam: { ...this.blankTeam },
        };

    }

    onChange = (e, type) => {
        this.props.log('Teams.js/onChange (e,type)', e, type);
        e.persist();
        let thisTeam = (type === 'edit') ? this.state.editTeam : this.state.newTeam;
        switch (e.target.name) {
            case "active":
                thisTeam[e.target.name] = !thisTeam[e.target.name];
                break;
            default:
                thisTeam[e.target.name] = e.target.value;
        }
        this.setState(() => {
            return (type === 'edit') ? { editTeam: thisTeam } : { newTeam: thisTeam };
        });
    }

    onEdit = (id) => {
        this.props.log('Teams.js/onEdit (id)', id);
        const team = [...this.props.teams].filter(item => item.id === id)[0];
        this.setState(() => {
            return {
                editTeam: {
                    'id': id,
                    'teamName': team.teamName,
                    'active': team.active,
                }
            }
        })
    }

    onDelete = (id) => {
        this.props.log('Teams.js/onDelete (id)', id);
        fetch('/api/teams/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Team deleted successfully.', 5, 'success')
                    let teams = [...this.props.teams];
                    teams.splice(teams.findIndex(item => item.id === id), 1);
                    this.setState({
                        teams: teams,
                        editTeam: { ...this.blankTeam },
                    }, () => this.props.getTeams());
                } else {
                    this.props.addToast('Unable to delete team.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleCancel = () => {
        this.props.log('Teams.js/handleCancel');
        this.setState({
            editTeam: { ...this.blankTeam },
        })
    }

    handleEdit = () => { // TODO
        this.props.log('Teams.js/handleEdit');
        fetch('/api/teams/' + this.state.editTeam.id, {
            method: 'PUT',
            body: JSON.stringify({
                teamName: this.state.editTeam.teamName,
                active: this.state.editTeam.active,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editTeam: { ...this.blankTeam }
                    }, () => this.props.getTeams());
                    this.props.addToast('Team updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update team.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleAdd = (e) => {
        this.props.log('Teams.js/handleAdd');
        fetch('/api/teams/', {
            method: 'POST',
            body: JSON.stringify({
                teamName: this.state.newTeam.teamName,
                active: this.state.newTeam.active,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Team added successfully.', 5, 'success')
                    this.setState({
                        newTeam: { ...this.blankTeam }
                    }, () => this.props.getTeams());
                } else {
                    this.props.addToast('Unable to add team.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    standardRow = (team) => {
        this.props.info('Teams.js/standardRow (team)', team);
        return (
            <Row className="adminRow pointer" onClick={() => this.onEdit(team.id)}>
                <Col md={12} className="text-left">
                    <FontAwesomeIcon icon={(team['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((team['active']) ? 'iconActive' : 'iconInactive')} />
                    {team['teamName']}
                </Col>
            </Row>
        )
    }

    editRow = (team) => {
        this.props.log('Teams.js/editRow (team)', team);
        return (
            <Row className="editRow adminRow activeTab">
                <Col md={8} className="text-left">
                    <Form inline>
                        <FormGroup className="pr-2">
                            <Input
                                placeholder="Team"
                                type="text"
                                id="teamName-edit"
                                name="teamName"
                                value={this.props.isFieldNull(this.state.editTeam.teamName)}
                                onChange={e => this.onChange(e, 'edit')} />
                        </FormGroup>
                        <FormGroup className="pr-2">
                            <Input
                                type="checkbox"
                                id={"edit-active" + team.id}
                                name="active"
                                checked={this.props.isFieldNull(this.state.editTeam.active, true)}
                                onChange={e => this.onChange(e, 'edit')} />
                            <Label for={"edit-active" + team.id}>
                                Active
                            </Label>
                        </FormGroup>
                    </Form>
                </Col>
                <Col md={4} className="text-right">
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Teams">
                        <Button className="mx-1" color="success" onClick={this.handleEdit} title="Edit Team">
                            <FontAwesomeIcon icon={faCheck} />
                        </Button>
                    </PermissionWrapper>
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Teams">
                        <ConfirmButton color="danger" className="mx-3"
                            onClick={() => this.onDelete(team.id)} title="Delete Team">
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </ConfirmButton>
                    </PermissionWrapper>
                    <Button className="mx-1" color="secondary" onClick={this.handleCancel} title="Cancel">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </Col>
            </Row>
        )
    }

    addRow = () => {
        this.props.info('Teams.js/addRow');
        return (
            <Row className="py-4 text-left align-items-bottom ">
                <Col>
                    <Form inline>
                        <FormGroup className="pr-2">
                            <Input
                                placeholder="New Team"
                                type="text"
                                id="teamName-add"
                                name="teamName"
                                value={this.props.isFieldNull(this.state.newTeam.teamName)}
                                onChange={e => this.onChange(e)} />
                        </FormGroup>
                        <FormGroup className="pr-2">
                            <Input
                                type="checkbox"
                                id={"teamActive-add"}
                                name="active"
                                checked={this.props.isFieldNull(this.state.newTeam.active, true)}
                                onChange={e => this.onChange(e)} />
                            <Label for={"teamActive-add"}>
                                Active
                            </Label>
                        </FormGroup>
                    </Form>
                </Col>
                <Col md={3} className="text-right">
                    <Button
                        disabled={this.state.newTeam.teamName === ''}
                        color="primary"
                        onClick={this.handleAdd}
                    >Add Team</Button>
                </Col>
            </Row>
        )
    }

    render() {
        return (
            <Container className="adminContainer" fluid>
                {this.props.teams.map(team => (
                    <Fragment key={team.id}>{this.state.editTeam.id === team.id ? this.editRow(team) : this.standardRow(team)}</Fragment>
                ))}
                <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Teams">
                    {this.addRow()}
                </PermissionWrapper>
            </Container>
        );

    }
}

export default Teams;